import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Row,
	Col,
	Input,
	Label,
	FormGroup
} from 'reactstrap';
import { format } from 'date-fns';
import * as commonActions from '@common/common.action';
import ArqivamentoApi from '../../../../arquivamento.api';
import WebapiCommon from '@common/util/webapi.common';
import { DebounceInput } from 'react-debounce-input';
import SelectComponent from '@componentes/select/select.component';
import {
	arquivamentoManualTipoEmum,
	arquivamentoManualTipoOptions,
	requisicaoMaterialTipoEntregaEmum,
	requisicaoMaterialTipoEntregaOptions
} from '../../../../arquivamento.utils';

import { getUsuarioLocalStorage } from '../../../../../../localStorage.util';

import Item from './Item';
import ModalInformacao from '../Informacao';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export default function ModalAdicionarRequisicao(props) {
	const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

	const backdrop = !props.backdrop ? false : props.backdrop;
	const keyboard = props.keyboard === undefined ? true : props.keyboard;
	const dispatch = useDispatch();
	const [modalAberto, setModalAberto] = useState(false);
	const [showModalInformacao, setShowModalInformacao] = useState(false);
	const [requisicaoMaterial, setRequisicaoMaterial] = useState({});

	const [laudoSelecionado, setLaudoSelecionado] = useState();
	const [all, setAll] = useState(true);
	const [laminas, setLaminas] = useState([]);
	const [blocos, setBlocos] = useState([]);
	const [laminasSelecionadas, setLaminasSelecionadas] = useState([]);
	const [blocosSelecionados, setBlocosSelecionados] = useState([]);
	const [
		itensArquivadosAnteriormente,
		setItensArquivadosAnteriormente
	] = useState([]);

	useEffect(() => {
		setModalAberto(props.showModalAdicionarMaterial);
		dispatch(commonActions.showModal(props.showModalAdicionarMaterial));

		const user = getUsuarioLocalStorage();
		setRequisicaoMaterial({
			dataPrevista: format(new Date(), 'yyyy-MM-dd'),
			usuarioId: user.usuarioId,
			nomeUsuarioRequisitado: user.usuario,
			tipo: arquivamentoManualTipoOptions.find(
				x => x.value === arquivamentoManualTipoEmum.BLOCO_LAMINA
			),
			nrExame: ''
		});
		setBlocos([]);
		setLaminas([]);
		setLaudoSelecionado(null);
	}, [props.showModalAdicionarMaterial]);

	useEffect(() => {
		setAll(
			blocosSelecionados.length === blocos.length &&
			laminasSelecionadas.length === laminas.length
		);
	}, [blocosSelecionados, laminasSelecionadas]);


	function limparLaminasBlocosSelecionados() {
		setBlocos([]);
		setLaminas([]);
		setBlocosSelecionados([]);
		setLaminasSelecionadas([]);
	}

	function toggle() {
		setModalAberto(!modalAberto);
		dispatch(commonActions.showModal(!modalAberto));
		props.onModal(!modalAberto);
	}

	function buscarLaudo(nrExame) {
		dispatch(commonActions.showFadeCarregando(true));
		ArqivamentoApi.getExameRequisicao(nrExame)
			.then(resp => {
				if (resp) {
					setLaudoSelecionado(resp.laudo);
					buscarBlocosELaminas(resp.laudo);
				} else {
					dispatch(commonActions.showFadeCarregando(false));
				}
			})
			.catch(() => {
				dispatch(commonActions.showFadeCarregando(false));
				setLaudoSelecionado(null);
				setLaminas([]);
				setBlocos([]);
			});
	}

	async function buscarBlocosELaminas(laudoId) {
		const [blocosLista, laminasLista] = await Promise.all([
			WebapiCommon.getBlocosExameMacroFinalizada(laudoId),
			WebapiCommon.getLaminasExameMicroFinalizada(laudoId)
		]);
		limparLaminasBlocosSelecionados();

		if (!blocosLista.length || !laminasLista.length) {
			dispatch(
				commonActions.showAlerta(
					'alerta',
					<IntlMessage id="general.materialArchiving.noBlocksOrSlidesAvailable" />,
					3000,
					'500px'
				)
			);
		}
		else {
			setBlocos(blocosLista);
			setLaminas(laminasLista);
			setBlocosSelecionados(blocosLista.map(x => x.value));
			setLaminasSelecionadas(laminasLista.map(x => x.value));
		}

		dispatch(commonActions.showFadeCarregando(false));
	}

	function onClickAll() {
		setAll(!all);
		if (!all) {
			setBlocosSelecionados(blocos.map(x => x.value));
			setLaminasSelecionadas(laminas.map(x => x.value));
		} else {
			setBlocosSelecionados([]);
			setLaminasSelecionadas([]);
		}
	}

	function salvar() {
		let itens = [];
		if (
			requisicaoMaterial.tipo.value ===
			arquivamentoManualTipoEmum.BLOCO_LAMINA ||
			requisicaoMaterial.tipo.value === arquivamentoManualTipoEmum.BLOCO
		) {
			blocosSelecionados.forEach(x =>
				itens.push(blocos.find(b => b.value === x))
			);
		}
		if (
			requisicaoMaterial.tipo.value ===
			arquivamentoManualTipoEmum.BLOCO_LAMINA ||
			requisicaoMaterial.tipo.value === arquivamentoManualTipoEmum.LAMINA
		) {
			laminasSelecionadas.forEach(x =>
				itens.push(laminas.find(l => l.value === x))
			);
		}
		const item = {
			...requisicaoMaterial,
			laudo: laudoSelecionado,
			itens
		};

		dispatch(commonActions.showFadeCarregando(true));
		ArqivamentoApi.postRequisicao(item).then(resp => {
			dispatch(commonActions.showFadeCarregando(false));
			showRetornoRequisicao(resp);
			dispatch(
				commonActions.showAlerta(
					'sucesso',
					<IntlMessage id="general.materialArchiving.requestMadeSuccessfully" />,
					3000
				)
			);
		});
	}

	function showRetornoRequisicao(resp) {
		if (!!resp.length) {
			const respFormatada = resp.map(x => {
				return {
					...x,
					numeroMaterial: `${x.tipo === arquivamentoManualTipoEmum.BLOCO ? `${intl.formatMessage({id:"general.materialArchiving.block"}) }` : `${intl.formatMessage({id:"general.materialArchiving.blade"}) }`
						} ${x.numeroMaterial}`
				};
			});
			setItensArquivadosAnteriormente(respFormatada);
			setShowModalInformacao(!showModalInformacao);
		}
	}


	return (
		<React.Fragment>
			<ModalInformacao
				onModal={() => setShowModalInformacao(!showModalInformacao)}
				itensArquivadosAnteriormente={itensArquivadosAnteriormente}
				showModalInformacao={showModalInformacao}
			/>
			<div>
				<Modal
					className='modal-lg modal-confirmacao-requisicao-material'
					centered
					backdrop={backdrop}
					keyboard={keyboard}
					isOpen={modalAberto}
					toggle={toggle}
				>
					<ModalHeader toggle={!props.close ? toggle : props.close}>
						<IntlMessage id="general.materialArchiving.confirmationForMaterialRequisition" />
					</ModalHeader>

					<ModalBody>
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.requester" />:</Label>
									<SelectComponent
										options={props.tecnicos.filter(x => x.value !== 0)}
										value={requisicaoMaterial.idRequisitante}
										onChange={e =>
											setRequisicaoMaterial({
												...requisicaoMaterial,
												idRequisitante: e
											})
										}
										placeholder={translate("general.materialArchiving.selectTheApplicant")}
										styles={{ borderColor: 'transparent' }}
									/>
								</FormGroup>
							</Col>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.user" />:</Label>
									<Input
										value={requisicaoMaterial.nomeUsuarioRequisitado}
										readOnly={true}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.expectedDate" />:</Label>
									<DebounceInput
										className='date'
										debounceTimeout={900}
										type='date'
										value={requisicaoMaterial.dataPrevista}
										onChange={e =>
											setRequisicaoMaterial({
												...requisicaoMaterial,
												dataPrevista: e.target.value
											})
										}
									/>
								</FormGroup>
							</Col>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.examNumber" />:</Label>
									<DebounceInput
										debounceTimeout={1900}
										className='form-control'
										type='text'
										value={requisicaoMaterial.nrExame}
										onChange={e => {
											buscarLaudo(e.target.value)
											setRequisicaoMaterial({
												...requisicaoMaterial,
												nrExame: e.target.value
											})
										}}
										onKeyPress={e => {
											if (e.key === 'Enter') {
												buscarLaudo(e.target.value);
											}
										}}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.destiny" />:</Label>
									<SelectComponent
										options={requisicaoMaterialTipoEntregaOptions.filter(
											x =>
												x.value !==
												requisicaoMaterialTipoEntregaEmum.NAO_INFORMADO
										)}
										value={requisicaoMaterial.tipoEntrega}
										onChange={e =>
											setRequisicaoMaterial({
												...requisicaoMaterial,
												tipoEntrega: e
											})
										}
										placeholder={translate("general.materialArchiving.selectDestination")}
										styles={{ borderColor: 'transparent' }}
										disabled={!laudoSelecionado}
									/>
								</FormGroup>
							</Col>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.type" />:</Label>
									<SelectComponent
										options={arquivamentoManualTipoOptions}
										value={requisicaoMaterial.tipo}
										onChange={e =>
											setRequisicaoMaterial({
												...requisicaoMaterial,
												tipo: e
											})
										}
										placeholder={translate("general.materialArchiving.selectType")}
										styles={{ borderColor: 'transparent' }}
										disabled={!laudoSelecionado}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id="general.materialArchiving.reason" />:</Label>
									<Input
										type='textarea'
										rows={3}
										value={requisicaoMaterial.motivo}
										disabled={!laudoSelecionado}
										onChange={e =>
											setRequisicaoMaterial({
												...requisicaoMaterial,
												motivo: e.target.value
											})
										}
									/>
								</FormGroup>
							</Col>
						</Row>
						{(!!laminas.length || !!blocos.length) && (
							<Row>
								<Col style={{ marginTop: '20px', marginBottom: '15px' }}>
									<i
										style={{ cursor: 'pointer', marginRight: '10px' }}
										onClick={onClickAll}
										className={all ? 'far fa-check-square' : 'far fa-square'}
									/>
									<Label className='checkbox-all' check onClick={onClickAll}>
										<IntlMessage id="dashboards.examDetail.selectAll" />
									</Label>
								</Col>
							</Row>
						)}

						{(!!laminas.length || !!blocos.length) && (
							<div style={{ maxHeight: '50vh', overflow: 'hidden scroll' }}>
								{(requisicaoMaterial.tipo.value ===
									arquivamentoManualTipoEmum.BLOCO_LAMINA ||
									requisicaoMaterial.tipo.value ===
									arquivamentoManualTipoEmum.BLOCO) && (
										<Item
											titulo={intl.formatMessage({id:"dashboards.examDetail.block"})}
											itens={blocos}
											selecionados={blocosSelecionados}
											setSelecionados={setBlocosSelecionados}
										/>
									)}
								{(requisicaoMaterial.tipo.value ===
									arquivamentoManualTipoEmum.BLOCO_LAMINA ||
									requisicaoMaterial.tipo.value ===
									arquivamentoManualTipoEmum.LAMINA) && (
										<Item
											titulo={intl.formatMessage({id:"general.materialArchiving.blade"})}
											itens={laminas}
											selecionados={laminasSelecionadas}
											setSelecionados={setLaminasSelecionadas}
										/>
									)}
							</div>
						)}
					</ModalBody>

					<ModalFooter>
						<Button
							onClick={!props.cancelar ? toggle : props.cancelar}
							className={`button-cancel`}
							color='secondary'
						>
							<IntlMessage id="general.materialArchiving.close" />
						</Button>
						<Button
							color='primary'
							onClick={() => salvar()}
							disabled={
								!laudoSelecionado ||
								!requisicaoMaterial.motivo ||
								!requisicaoMaterial.tipoEntrega
							}
						>
							<IntlMessage id="general.materialArchiving.save" />
						</Button>
					</ModalFooter>
				</Modal>
			</div>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/modais/AdicionarRequisicao/index.js